module.exports = __webpack_public_path__ + "assets/no-articles-found.16fe811f.svg";